import { CareCard } from "./CareCard"

export function ContactCard({ contact, bullets }: { contact: string; bullets: string[] }): JSX.Element {
  const heading = `Contact ${contact} if:`
  return (
    <CareCard heading={heading}>
      <ul>
        {bullets.map((bullet) => (
          <li key={bullet}>{bullet}</li>
        ))}
      </ul>
    </CareCard>
  )
}
